import { IOrder } from '@monofront/types';
import { useTranslations } from 'next-intl';

interface ICancelLink {
  order: IOrder;
  onClick: (order: IOrder) => void | Promise<void>;
}

export const CancelLink: React.FC<ICancelLink> = ({ order, onClick }) => {
  const tGlobal = useTranslations('Global');

  return (
    <a
      href="#cancel_order"
      className="tw-lf-link-md"
      onClick={(e) => {
        e.preventDefault();
        onClick(order);
      }}
      data-testid="CancelLink-go-to-cancel-order"
    >
      {tGlobal('cancel')}
    </a>
  );
};
